const hmrequest = require('@/utils/hmrequests')
const { getSessionOwnerParams } = require('@/utils/auth')

const normalizeSessionParams = (identityOrUserId) => {
  if (identityOrUserId && typeof identityOrUserId === 'object' && !Array.isArray(identityOrUserId)) {
    return identityOrUserId
  }
  if (identityOrUserId !== undefined && identityOrUserId !== null && identityOrUserId !== '') {
    return { user_id: identityOrUserId }
  }
  return getSessionOwnerParams()
}

const getUserSessions = async (identityOrUserId) => {
  try {
    return await hmrequest.get('/chat/sessions', {
      params: normalizeSessionParams(identityOrUserId)
    })
  } catch (error) {
    console.error('获取用户会话列表失败:', error)
    throw error
  }
}

const getSessionMessages = async (sessionId) => {
  try {
    return await hmrequest.get(`/chat/messages/${sessionId}`)
  } catch (error) {
    console.error('获取会话消息失败:', error)
    throw error
  }
}

const getWorkflowMonitor = async () => {
  try {
    return await hmrequest.get('/chat/monitor/overview')
  } catch (error) {
    console.error('获取工作流监控数据失败:', error)
    throw error
  }
}

const getEvaluationDashboard = async () => {
  try {
    return await hmrequest.get('/chat/evals/dashboard')
  } catch (error) {
    console.error('获取评估仪表盘失败:', error)
    throw error
  }
}

const startRecentChatEvals = async (limit = 10) => {
  try {
    return await hmrequest.post('/chat/evals/recent/start', { limit })
  } catch (error) {
    console.error('启动最近消息回放评估失败:', error)
    throw error
  }
}

const startPerformanceProbe = async (sampleSize = 6, concurrency = 2) => {
  try {
    return await hmrequest.post('/chat/evals/performance/start', {
      sample_size: sampleSize,
      concurrency
    })
  } catch (error) {
    console.error('启动性能探针失败:', error)
    throw error
  }
}

const startUnitTestSuite = async () => {
  try {
    return await hmrequest.post('/chat/evals/unit-tests/start', {})
  } catch (error) {
    console.error('启动单元测试套件失败:', error)
    throw error
  }
}

const startGoldenSetBuild = async (maxItems = 120) => {
  try {
    return await hmrequest.post('/chat/evals/golden-set/start', {
      max_items: maxItems
    })
  } catch (error) {
    console.error('启动 Golden Set 构建失败:', error)
    throw error
  }
}

const getEvalTask = async (taskId) => {
  try {
    return await hmrequest.get(`/chat/evals/tasks/${taskId}`)
  } catch (error) {
    console.error('获取评估任务状态失败:', error)
    throw error
  }
}

const getAgentConfigs = async () => {
  try {
    return await hmrequest.get('/chat/agents/config')
  } catch (error) {
    console.error('获取智能体配置失败:', error)
    throw error
  }
}

const updateAgentConfig = async (agentName, payload) => {
  try {
    return await hmrequest.put(`/chat/agents/${agentName}/config`, payload)
  } catch (error) {
    console.error('更新智能体配置失败:', error)
    throw error
  }
}

const updateSceneConfig = async (sceneName, payload) => {
  try {
    return await hmrequest.put(`/chat/scenes/${sceneName}/config`, payload)
  } catch (error) {
    console.error('更新场景配置失败:', error)
    throw error
  }
}

const deleteSession = async (sessionId) => {
  try {
    return await hmrequest.delete(`/chat/sessions/${sessionId}`)
  } catch (error) {
    console.error('删除会话失败:', error)
    throw error
  }
}

module.exports = {
  getUserSessions,
  getSessionMessages,
  getWorkflowMonitor,
  getEvaluationDashboard,
  startRecentChatEvals,
  startPerformanceProbe,
  startUnitTestSuite,
  startGoldenSetBuild,
  getEvalTask,
  getAgentConfigs,
  updateAgentConfig,
  updateSceneConfig,
  deleteSession
}
